import { AgentInterface } from "../Agent/Agent.Interface";
import { AppendTenantNoteResponse } from "../FMS/FMS.Interfaces";
import { OrgBaseInterface } from "../Shared/OrgBase.Interace";
import { TenantInterface } from "../Tenant/Tenant.Interface";
import { UserInterface } from "../User/User.Interface";

export interface NoteInterface extends OrgBaseInterface {
  id: number;
  userId: number;
  user?: UserInterface;
  slug?: string; // Optional slug to update the note if it already exists
  // tenantId?: number;
  // tenant?: TenantInterface;

  // externalId?: string; // this is used to store the FMS note id
  syncStatus?: NoteSyncStatus;
  /** Why the FMS sync ended as it did: the Outbound Gate's reason on `SIMULATED` (`flag_off`, `not_listed`), the FMS's message on `SYNC_FAILED`. */
  syncDetail?: string | null;
  title?: string;
  content: string;
  pinned?: boolean;
  archived?: boolean;
  createdBy: NoteCreatedBy;
  raw?: any;
}

export enum NoteCreatedByType {
  Member = "member",
  System = "system",
  Workflow = "workflow"
}
export interface NoteCreatedBy {
  creator: NoteCreatedByType;
  questName?: string;
  questSlug?: string;
  nodeId?: string;
  memberId?: number;
}

export enum NoteSyncStatus {
  SYNCED = "SYNCED",
  SYNC_FAILED = "SYNC_FAILED",
  SYNC_NOT_REQUIRED = "SYNC_NOT_REQUIRED",
  /** ENG-3373: the Outbound Gate withheld the FMS write — built, recorded, never written; `syncDetail` says why. */
  SIMULATED = "SIMULATED"
}

/** The one wording every note card uses for its FMS sync badge. Empty when no sync was required. */
export function noteSyncLabel(note: Pick<NoteInterface, "syncStatus" | "syncDetail">): string {
  const detail = note.syncDetail?.replace(/_/g, " ");
  switch (note.syncStatus) {
    case NoteSyncStatus.SYNCED:
      return "Synced";
    case NoteSyncStatus.SYNC_NOT_REQUIRED:
      return "";
    case NoteSyncStatus.SIMULATED:
      return `Not synced — simulated${detail ? ` (${detail})` : ""}`;
    case NoteSyncStatus.SYNC_FAILED:
      return `Not synced${detail ? ` — ${detail}` : ""}`;
    default:
      return "Sync Pending";
  }
}

export function noteSyncResultFromFmsResponse(response: AppendTenantNoteResponse | undefined): Pick<NoteInterface, "syncStatus" | "syncDetail"> {
  if (response?.isSuccess) return { syncStatus: NoteSyncStatus.SYNCED, syncDetail: null };
  if (response?.simulated) return { syncStatus: NoteSyncStatus.SIMULATED, syncDetail: response.gateReason ?? null };
  return { syncStatus: NoteSyncStatus.SYNC_FAILED, syncDetail: response?.responseMessage?.slice(0, 160) ?? null };
}

export function noteSyncResultFromError(error: unknown): Pick<NoteInterface, "syncStatus" | "syncDetail"> {
  return { syncStatus: NoteSyncStatus.SYNC_FAILED, syncDetail: (error instanceof Error ? error.message : String(error)).slice(0, 160) };
}
